import { CacheHeight } from "./CacheHeight";
import { kAddIconCirlce, kChineseFonts, kSearchIcon } from "../constants";
import { LookupHeight } from "./LookupHeight";
import { doMeasureTextHeight } from "./doMeasureTextHeight";

export function MeasureTextHeightAdv(fontString, fontSize, fontIcon) {
  var txtHeight = LookupHeight(fontString);
  if (txtHeight != null) return txtHeight;

  var totalHeightString = "MylgWhjP";
  var noHangHeightString = "MlWhP@OLC";

  if (fontIcon) {
    totalHeightString = kSearchIcon;
    noHangHeightString = kAddIconCirlce;
  } else {
    for (var c = 0; c < kChineseFonts.length; c++) {
      if (fontString.indexOf(kChineseFonts[c]) != -1) {
        totalHeightString = "MylgWhjP重点客户经理";
        noHangHeightString = "MlWhP重点客户经理";
      }
    }
  }
  var totalHeight = doMeasureTextHeight(fontString, fontSize, totalHeightString); // 重点客户经理");
  var noHangHeight = doMeasureTextHeight(fontString, fontSize, noHangHeightString); // 重点客户经理");

  var t = CacheHeight(fontString, totalHeight, noHangHeight);
  return t;
}
